import requestAction from '../../utils/requestAction'
import Country from '../../models/Country';

export const upsertCountry = (country: (Country)) =>
  requestAction('COUNTRY_UPSERT')(
    `countries${(country as Country).id ? `/${(country as Country).id}` : ''}`,
    (country as Country).id ? 'PUT' : 'POST',
    country
  )
